<template>
  <div class="wrapper">
    <div class="section section-pricing-2">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-60 md-small-size-100">
            <md-card class="md-card-contact">
              <md-card-header class="md-card-header-primary text-center">
                <h4 class="title" style="color:white">
                  {{ $t("Notice") }}
                </h4>
              </md-card-header>
              <md-card-content>
                <md-button class="md-primary md-fileinput">
                  {{ $t("Select File") }}
                  <md-input type="file" accept=".pdf" @change="onSelect" />
                </md-button>
                <br />
                <div
                  v-if="selectedFile != ''"
                  class="md-layout"
                  style="align-items: center;"
                >
                  <div class="md-layout-item md-medium-size-30">
                    <label>{{ selectedFile }}</label>
                  </div>
                  <div class="md-layout-item md-medium-size-30">
                    <md-button class="md-simple md-primary" @click="onUpload"
                      >{{ $t("Upload") }}
                    </md-button>
                  </div>
                </div>
                <div
                  v-if="noticeUrl != ''"
                  class="md-layout"
                  style="align-items: center;"
                >
                  <div class="md-layout-item md-medium-size-30">
                    <a target="_blank" :href="noticeUrl">{{ noticeUrl }}</a>
                  </div>
                  <div class="md-layout-item md-medium-size-30">
                    <md-button class="md-simple md-primary" @click="onDelete"
                      >{{ $t("Delete") }}
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { EventBus, NOTICE_URL } from "@/helpers";

export default {
  data() {
    return {
      selectedFile: "",
      noticeData: null,
      noticeUrl: ""
    };
  },
  computed: {
    ...mapFields("auth", ["airport_id"]),
    ...mapFields("airport", ["notice"])
  },
  mounted() {
    this.$store.dispatch("airport/getNotice", this.airport_id);

    EventBus.$on("setNotice", () => {
      if (this.notice) {
        this.noticeUrl = NOTICE_URL + this.airport_id + ".pdf";
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("setNotice");
  },
  methods: {
    onSelect(e) {
      var self = this;
      const file = e.target.files[0];
      this.selectedFile = file.name;
      var fileReader = new FileReader();
      fileReader.onload = function(fileLoadedEvent) {
        var base64 = fileLoadedEvent.target.result;
        self.noticeData = base64.split(",")[1];
      };
      fileReader.readAsDataURL(file);
    },
    onUpload() {
      this.$store.dispatch("airport/uploadNotice", {
        noticeData: this.noticeData
      });
      this.selectedFile = "";
      this.noticeData = null;
    },
    onDelete() {
      this.$store.dispatch("airport/deleteNotice");
      this.noticeUrl = "";
    }
  }
};
</script>
